import type { ComponentType } from 'react';
import { Icon, type IconName } from '@/components/ui/icon';

interface EmptyStateProps {
  /** Prototype icon name, or a legacy lucide/component icon. */
  icon?: IconName | ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
  title?: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({
  icon = 'sparkle',
  title = 'Nothing here yet',
  description,
  action,
}: EmptyStateProps) {
  const isName = typeof icon === 'string';
  const LegacyIcon = icon as ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
  return (
    <div className="wb-empty">
      <div className="wb-empty-ico">
        {isName ? (
          <Icon name={icon as IconName} size={34} />
        ) : (
          <LegacyIcon className="h-8 w-8" aria-hidden={true} />
        )}
      </div>
      <div className="wb-h2">{title}</div>
      {description && (
        <div className="wb-sub" style={{ maxWidth: 320 }}>
          {description}
        </div>
      )}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="wb-btn wb-btn--primary wb-btn--sm"
          style={{ marginTop: 16 }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
